import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const intlPhone = "+923158182288";
  const waPhone = "923158182288";

  return (
    <footer className="bg-black text-gray-300 py-10 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
        {/* Brand / About */}
        <div>
          <h2 className="text-2xl font-bold mb-3">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">
              Rawangi
            </span>{" "}
            {t("footer.brand")}
          </h2>

          <p className="text-gray-400 text-sm leading-relaxed">
            {t("footer.about")}
          </p>
        </div>

        {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">
              {t("footer.quickLinks")}
            </h3>

            <ul className="space-y-2 text-gray-400">
              <li><Link to="/" className="hover:text-blue-400 transition">{t("nav.home")}</Link></li>
              <li><Link to="/about" className="hover:text-blue-400 transition">{t("nav.about")}</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition">{t("nav.services")}</Link></li>
              <li><Link to="/umrahtickets" className="hover:text-blue-400 transition">{t("nav.umrahtickets")}</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400 transition">{t("nav.contact")}</Link></li>
              <li><Link to="/faqs" className="hover:text-blue-400 transition">{t("nav.faqs")}</Link></li>
            </ul>
          </div>
        {/* Contact */}
        <div>
          <h3 className="text-xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">
            {t("footer.contact")}
          </h3>

          <p className="text-gray-400 text-sm">
            <span className="block">{t("footer.address.line1")}</span>
            <span className="block">{t("footer.address.line2")}</span>
            <span className="block mb-2">{t("footer.address.line3")}</span>

            <span className="block">
              📞{" "}
              <a href={`tel:${intlPhone}`} className="hover:text-blue-400 transition">
                03158182288
              </a>
            </span>

            <span className="block">
              ✉️{" "}
              <a href="mailto:rawangi001@gmail.com" className="hover:text-blue-400 transition">
                rawangi001@gmail.com
              </a>
            </span>
          </p>

          <div className="flex gap-3 mt-4">
            <a
              href={`tel:${intlPhone}`}
              aria-label={t("footer.callAria")}
              className="px-4 py-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:opacity-90 transition"
            >
              {t("footer.callNow")}
            </a>

            <a
              href={`https://wa.me/${waPhone}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.whatsappAria")}
              className="px-4 py-2 rounded-full bg-gradient-to-r from-green-500 to-green-600 text-white hover:opacity-90 transition"
            >
              {t("footer.whatsapp")}
            </a>
          </div>

          <div className="mt-4 text-sm text-gray-400">
            <a
              href="https://www.facebook.com/RawangiTravelandTours/#"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-blue-400 transition"
            >
              Facebook
            </a>
            <a
              href="https://x.com/RawangiT"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-blue-400 transition"
            >
              X (Twitter)
            </a>
          </div>
        </div>
      </div>

      <div className="text-center text-gray-500 text-sm border-t border-gray-800 mt-10 pt-6">
        © {new Date().getFullYear()} Rawangi Travels &amp; Tours. {t("footer.rights")}
      </div>
    </footer>
  );
};

export default Footer;
